var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{class:("list-disc " + _vm.extraClass)},_vm._l((_vm.items),function(item){return _c('list-li',{key:item,class:_vm.extraLiClass,attrs:{"content":item}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }